import React, { useEffect } from "react";
import { useNavigate } from 'react-router-dom';


const NoPage = () => {
    const navigate = useNavigate();
    localStorage.clear();
    useEffect(() => {

        const params = new URLSearchParams(window.location.search);
        const token = params.get('token');

        if (token) {
            localStorage.setItem("tokenn", token);
            navigate('/dashboard');
        } else {
            window.location.href = process.env.REACT_APP_MAT_URL;
            localStorage.clear();
        }
    }, [navigate]);


    return (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: "100vh", maxWidth: "100%" }}>

            <p>Redirecting to TelKosh...</p>

        </div>
    )
};

export default NoPage;